// assets/wishlist-hero-section.js

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/a/wishlist-hero')) {
    const mainContent = document.getElementById('MainContent');
    const wishlistSection = document.getElementById('wishlist-hero-shared-list-view');

    if (mainContent && wishlistSection) {
      const graphicSection = document.createElement('div');
      graphicSection.classList.add('wishlist-graphic-section');
      graphicSection.innerHTML = `
        <svg class="graphic-svg" style="--height: auto; --sm-height: auto;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 360" preserveAspectRatio="none">
          <polygon class="layer-main" points="0 279 0 359 0 360 1600 360 1600 359 0 279" fill="var(--color-background)"></polygon>
          <path class="layer-secondary" d="M1600,0L200,360h1400V0Z" fill="var(--color-background)" style="opacity:0.15;"></path>
        </svg>
      `;
      mainContent.insertBefore(graphicSection, wishlistSection);
    }
  }
});
